import styled, { css } from "styled-components";
import type { ComboboxVariantsType } from "./Combobox";

// STYLES
const defaultCombobox = css`
    position: sticky;
    top: 0;
    padding: var(--spacing-3);
    background-color: var(--color-primary-white);
`;

// COMPONENTS
export const Box = styled.div``;

export const List = styled.ul`
    max-height: 300px;
    overflow-y: auto;
    margin-inline: calc(var(--spacing-3) * -1);
    padding: 0;
    list-style: none;

    li {
        display: block;
        padding-inline: var(--spacing-3);
        color: var(--color-primary-black);

        &:not(:nth-last-child(1)) {
            button {
                border-bottom: 1px solid var(--color-grey-4);
            }
        }

        &:is(:hover, :focus) {
            background-color: var(--color-grey-1);
        }
    }

    button {
        width: 100%;
        padding-block: var(--spacing-2);
        text-align: start;
    }
`;

export const ComboboxVariants = {
    default: defaultCombobox,
};

const ComboboxVariant = styled.div<{ variant: ComboboxVariantsType }>`
    ${({ variant }) =>
        variant &&
        css`
            ${ComboboxVariants[variant]};
        `};
`;

export default ComboboxVariant;
